Postlogin.Lesson = (function (my) {
    my.Hotspots = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container;
        const numberOfOptions = Object.keys(me.options).length;
        let numberOfCorrectOptions = 0;
        let numberMatched = 0;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            // set the number of options (used in css for displaying options)
            segmentContainer.attr('data-options-count', numberOfOptions);

            const hotspotImage = $('<div></div>').addClass('hotspot-image');
            hotspotImage.css('backgroundImage', `url(${me.activity_data.instructions_image})`);

            $.each(me.options, (i, option) => {
                if (option.correct) {
                    numberOfCorrectOptions++;
                }
            });

            $.each(me.options, (i, option) => {
                // add clickable hotspot
                const hotspot = $(`<a class="item option-${option.activity_option_id}"></a>`);
                hotspot.attr('data-option-id', option.activity_option_id);
                // Store as 1/0, not the raw boolean -- jQuery .attr() stringifies a JS
                // boolean to the literal text "true"/"false", and the click handler
                // below reads this back with `+correct === 1`, which is never true for
                // those strings (+"true" and +"false" both evaluate to NaN).
                hotspot.attr('data-correct', option.correct ? 1 : 0);
                hotspot.css('position', 'absolute');
                hotspot.css('left', `${option.answer}%`);
                hotspot.css('right', `${option.hint}%`);
                hotspot.css('top', `${option.answer_es}%`);
                hotspot.css('bottom', `${option.hint_es}%`);
                hotspot.css('width', `${option.hint - option.answer}%`);
                hotspot.css('height', `${option.hint_es - option.answer_es}%`);

                // adds a class that gives the user a hint after 1 minute + random interval of seconds between 4 and 1/2 second
                const timedHintInterval = setInterval(() => {
                    hotspot.addClass('timed-hint');
                    setTimeout(() => hotspot.removeClass('timed-hint'), 1000);
                }, 30000 + (Math.random() * (4000 - 500) + 1));

                hotspot.on('click', function () {
                    const correct = $(this).attr('data-correct');
                    const optionId = $(this).attr('data-option-id');
                    // remove the hint interval since they've already clicked on the item
                    clearInterval(timedHintInterval);

                    const feedbackTitle = me.options[optionId].feedback_title; // $.trim($('#option-feedback-'+optionId).attr('data-title'));
                    const feedbackAudio = me.options[optionId].feedback_audio; // $.trim($('#option-feedback-'+optionId).attr('data-audio'));
                    const feedbackBody = me.getOptionFeedback(optionId);

                    if (feedbackBody) {
                        let cssClass = '';
                        if (+correct === 1) {
                            if (!$(this).hasClass('correct')) {
                                numberMatched++;
                            }

                            Postlogin.Lesson.playSoundEffect('hotspot-click');
                            if (numberOfCorrectOptions !== numberOfOptions) {
                                cssClass = 'correct';
                            }
                        } else {
                            Postlogin.Lesson.playSoundEffect('incorrect');
                            cssClass = 'incorrect';
                        }

                        // show the option-feedback modal window
                        Postlogin.Lesson.Popup.showModal({
                            title: feedbackTitle,
                            body: feedbackBody,
                            class: cssClass,
                            overlay: 'light',
                            smaller: true,
                            actions: [
                                {
                                    label: 'Continue',
                                    cssClass: 'btn-xl btn-success btn-continue',
                                    onClick(e) {
                                        // $(e.target).parents('.modal').modal('hide');
                                        e.stopPropagation();
                                        Postlogin.Lesson.pauseCurrentSound();

                                        if (numberOfCorrectOptions === numberMatched) {
                                            Postlogin.Lesson.Popup.showCompletionModal(me);
                                        } else {
                                            Postlogin.Lesson.Popup.hideModal();
                                        }
                                    },
                                },
                                {
                                    label: 'Replay <i class="fa fa-volume-up"></i>',
                                    cssClass: 'btn-replay-audio btn-default pull-left',
                                    onClick(e) {
                                        e.stopPropagation();
                                        $(this).fadeOut();
                                        Postlogin.Lesson.playSound(feedbackAudio, 0, null, () => {
                                            $('#beep-9-modal .btn-replay-audio').fadeIn();
                                        });
                                    },
                                },
                            ],
                            onShow() {
                                $('#beep-9-modal .btn-replay-audio').hide();
                                if (feedbackAudio) {
                                    if (
                                        Postlogin.Lesson.soundEnabled()
                                        && !$(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).hasClass(
                                            `dont-disable-feedback-${optionId}continue`,
                                        )
                                    ) {
                                        $('#beep-9-modal .btn-continue').prop('disabled', true);
                                    }
                                    Postlogin.Lesson.playSound(feedbackAudio, 500, null, () => {
                                        $('#beep-9-modal .btn-replay-audio').fadeIn();
                                        $('#beep-9-modal .btn-continue').prop('disabled', false);
                                        $(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).addClass(
                                            `dont-disable-feedback-${optionId}continue`,
                                        );
                                    });
                                }
                            },
                            onHide() {
                                $(container)
                                    .find(`.item[data-option-id="${optionId}"]`)
                                    .each(function () {
                                        Postlogin.Lesson.pauseCurrentSound();
                                        if (+correct === 1) {
                                            $(this).addClass('correct');
                                        } else {
                                            $(this).addClass('incorrect');
                                        }
                                    });
                            },
                        });
                    } else {
                        Postlogin.Lesson.pauseCurrentSound();
                        if (+correct === 1) {
                            numberMatched++;
                            if (numberOfCorrectOptions !== numberOfOptions) {
                                Postlogin.Lesson.playSoundEffect('correct');
                            } else {
                                Postlogin.Lesson.playSoundEffect('hotspot-click');
                            }
                        } else {
                            Postlogin.Lesson.playSoundEffect('incorrect');
                        }

                        if (feedbackAudio) {
                            Postlogin.Lesson.playSound(feedbackAudio, 500);
                        }

                        if (numberOfCorrectOptions === numberMatched) {
                            setTimeout(() => {
                                Postlogin.Lesson.Popup.showCompletionModal(me);
                            }, 500);
                        }
                    }
                });

                hotspotImage.prepend(hotspot);
            });

            segmentContainer.append(hotspotImage);
            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        me.replay = function (forceShowHelp = false) {
            numberMatched = 0;

            $(container)
                .find('.item')
                .each(function () {
                    $(this).removeClass('correct');
                });

            Postlogin.Lesson.hideNextButton();

            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    if (me.completed && !me.last) {
                        Postlogin.Lesson.showNextButton();
                    }
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();
            me.replay();
        };

        me.hide = function () {
            me.breakdown();
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
